import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Thongkelaixe from "components/Thongke/Laixe/Thongkelaixe.js";
export default function Tklaixe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Tra cứu lái xe",
            tabContent: <Thongkelaixe />,
          },
        ]}
      />
    </div>
  );
}
